export default __webpack_public_path__ + "static/media/rectangle.7f24a1c6.png";